import React, { useState, useEffect } from "react";
import { CAMPAIGN_CREATE_LINK,
    CREATE_RECIPIENTS_IN_CAMPAIGN_LINK,
    COMPOSE_MESSAGE_FOR_CAMPAIGN_LINK, 
    MESSAGE_PREVIEW_FOR_CAMPAIGN_LINK,
    OPTIONS_FOR_CAMPAIGN_LINK,
    EDIT_CAMPAIGN_LINK,
    FINAL_STEP_FOR_CAMPAIGN_LINK
} from "../../constants/constants";
import { useParams } from "react-router-dom";

const Tabs = (props) => {
    const {campaignID} = useParams();
    const [campaignId, setCampaignId] = useState();
    const [activeTabs, setActiveTabs] = useState(props.currentTab);
    const handleTabClick = (name) => {
        if(campaignId === null){
            return;
        }
        if(name === 'start'){
            if(campaignId) {
                window.location.href = EDIT_CAMPAIGN_LINK.replace(':campaignID',campaignId);
            } else{
                window.location.href = CAMPAIGN_CREATE_LINK;
            }
            
        } else if(name === 'add-recipients'){
            window.location.href = CREATE_RECIPIENTS_IN_CAMPAIGN_LINK.replace(':campaignID',campaignId);
        } else if(name === 'compose'){
            window.location.href = COMPOSE_MESSAGE_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignId);
        } else if(name === 'preview'){
            window.location.href = MESSAGE_PREVIEW_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignId);
        } else if(name === 'options'){
            window.location.href = OPTIONS_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignId);
        } else if(name === 'send'){
            window.location.href = FINAL_STEP_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignId);
        }
        setActiveTabs(name);
    }
    useEffect(()=>{
        if(activeTabs === 'start' && props.campaignId){
            setCampaignId(props.campaignId);
        } else if(campaignID){
            setCampaignId(campaignID);
        }
    });
    return(<>
        <ul className="step-menu">
            <li 
            className={ activeTabs === 'start' ? 'active':(props.completedTabs !== undefined && (props.completedTabs).includes('start')?'enabled':'disabled')}
            onClick={()=>{
                handleTabClick('start');
            }}>Start</li>
            <li
            className={ activeTabs === 'add-recipients' ? 'active':(props.completedTabs !== undefined && (props.completedTabs).includes('add-recipients')?'enabled':'disabled')} 
            onClick={()=>{
                handleTabClick('add-recipients');
            }}>Recipients </li>
            <li
            className={ activeTabs === 'compose' ? 'active':(props.completedTabs !== undefined && (props.completedTabs).includes('compose')?'enabled':'disabled')} 
            onClick={()=>{
                handleTabClick('compose');
            }}>Compose</li>
            <li
            className={ activeTabs === 'preview' ? 'active':(props.completedTabs !== undefined && (props.completedTabs).includes('preview')?'enabled':'disabled')} 
            onClick={()=>{
                handleTabClick('preview');
            }}>Preview</li>
            <li
            className={ activeTabs === 'options' ? 'active':(props.completedTabs !== undefined && (props.completedTabs).includes('options')?'enabled':'disabled')} 
            onClick={()=>{
                handleTabClick('options');
            }}>Options</li>
            <li
            className={ activeTabs === 'send' ? 'active':(props.completedTabs !== undefined && (props.completedTabs).includes('send')?'enabled':'disabled')} 
            onClick={()=>{
                handleTabClick('send');
            }}>Send</li>
        </ul>
    </>);
}

export default Tabs;